var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorld(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 20C12.995 19.9999 14.9335 19.3372 16.511 18.116C18.0886 16.8948 19.2159 15.1843 19.716 13.253M11 20C9.00501 19.9999 7.06654 19.3372 5.48898 18.116C3.91141 16.8948 2.78408 15.1843 2.284 13.253M11 20C13.485 20 15.5 15.97 15.5 11C15.5 6.03 13.485 2 11 2M11 20C8.515 20 6.5 15.97 6.5 11C6.5 6.03 8.515 2 11 2M19.716 13.253C19.901 12.533 20 11.778 20 11C20.0025 9.45211 19.6039 7.92999 18.843 6.582M19.716 13.253C17.0492 14.7314 14.0492 15.5048 11 15.5C7.838 15.5 4.867 14.685 2.284 13.253M2.284 13.253C2.09475 12.517 1.99933 11.76 2 11C2 9.395 2.42 7.887 3.157 6.582M11 2C12.5962 1.99933 14.1639 2.42336 15.5422 3.22856C16.9205 4.03377 18.0597 5.19117 18.843 6.582M11 2C9.40376 1.99933 7.83608 2.42336 6.45781 3.22856C5.07954 4.03377 3.94031 5.19117 3.157 6.582M18.843 6.582C16.6657 8.46793 13.8805 9.50415 11 9.5C8.002 9.5 5.26 8.4 3.157 6.582",
    stroke: "#798CAF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.5299c47d7b0a89fddb02128b13e125b8.svg";
export { ForwardRef as ReactComponent };